import React, { useContext } from 'react';

import LeadConversationsContext, {
  ConversationChannel,
} from '../../../../context/LeadConversationsContext/LeadConversationsContext';

import texts from '../../texts.json';
import { StyledTabComponent } from './styles';

const tabsConfig = {
  [ConversationChannel.TEXT_EMAIL]: {
    label: texts.textEmailChannel,
  },
  [ConversationChannel.INSTAGRAM]: {
    label: texts.instagramChannel,
  },
};

const ConversationChannelSelect = () => {
  const {
    selectedChannel,
    setSelectedChannel,
  } = useContext(LeadConversationsContext);

  return (
    <StyledTabComponent
      tabsConfig={tabsConfig}
      selectedTab={selectedChannel}
      onSelectTab={setSelectedChannel}
    />
  );
};

export default ConversationChannelSelect;
